export default "__VITE_ASSET___bVM$hb7__"